import {ApiClientCommunication} from 'neo-common';
import {ConfigurationResponse} from '../Responses/ConfigurationResponse';

/**
 * @class BalanceRequest - Get balance request is used by client to obtain current balance of player.
 * It is used when game client is idle for some time or when client is forced to refresh balance by client host.
 */
export class ConfigurationRequest extends ApiClientCommunication.RequestBase<ConfigurationResponse> {
    createResponse(responseJson: ApiClientCommunication.Types.RawResponseType): ConfigurationResponse {
        return new ConfigurationResponse(responseJson);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Requests/ConfigurationRequest.ts
 **/